import React, { useContext } from "react"
import { Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import { StoreContext } from "../../../context/store"
import "./cart.css"
const Cart = ({ boxRef }) => {
  const { cart, cartOpen, toggleCart, updateQuantity } =
    useContext(StoreContext)

  return (
    <aside
      className={`cartbar ${
        cartOpen ? "translate-x-0" : "translate-x-full ease-in"
      } `}
    >
      <div className="side-container">
        <div className="flex items-center justify-between">
          <h3 className="text-2xl font-medium text-gray-700">Your cart</h3>
        </div>
        <hr className="my-3" />
        {cart.map((product, i) => {
          return (
            <div className="flex justify-between mt-6" key={product.id}>
              <div className="flex">
                <div className="w-1/3">
                  <GatsbyImage
                    image={product.image}
                    alt={product.title}
                    className="h-20 w-full"
                    objectFit="contain"
                    objectPosition="center"
                  ></GatsbyImage>
                </div>

                <div className="mx-3 w-2/3">
                  <h3 className="text-sm text-gray-600">{product.title}</h3>
                  <h4 className="text-xs mt-2 text-gray-500">
                    {product.vendor}
                  </h4>
                  <span className="text-gray-600">{product.price}Tk.</span>
                  <div className="flex items-center mt-2">
                    <button
                      className="text-gray-500 focus:outline-none focus:text-gray-600"
                      onClick={() => updateQuantity(i, 1)}
                    >
                      <svg
                        className="h-5 w-5"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                      </svg>
                    </button>
                    <span className="text-gray-700 mx-2">{product.qty}</span>
                    <button
                      className="text-gray-500 focus:outline-none focus:text-gray-600"
                      onClick={() => updateQuantity(i, -1)}
                    >
                      <svg
                        className="h-5 w-5"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path d="M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )
        })}

        {cart.length > 0 ? (
          <Link
            to="/checkout"
            onClick={() => toggleCart(false)}
            className="flex items-center justify-center mt-4 px-3 py-2 bg-primary text-white text-sm uppercase font-medium rounded hover:bg-black focus:outline-none focus:bg-black cursor-pointer"
          >
            <span>Chechout</span>
            <svg
              className="h-5 w-5 mx-2"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
            </svg>
          </Link>
        ) : (
          <h2 className="text-xl font-medium text-gray-600">Cart is Empty!</h2>
        )}
      </div>
    </aside>
  )
}

export default Cart
